import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import DisabledCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/DisabledCell'
import RestDayCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/RestDayCell'
import BankHolidayItem from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/ShiftCell/BankHolidayItem'
import LeaveItem from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/ShiftCell/LeaveItem'
import WrapperCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/WrapperCell'
import type { ColumnsType } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/buildColumns'
import { getResources } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/getResources'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { ShiftsRow } from 'modules/shift_management/lib/types'
import type DefaultShifts from 'modules/shift_management/store/internal/collections/DefaultShifts'

import ShiftsGrid from './ShiftsGrid'

export interface Props {
  shiftsRow: ShiftsRow
  columns: ColumnsType
  visibleDefaultShifts: DefaultShifts
}

const DailyRow = ({ shiftsRow, columns, visibleDefaultShifts }: Props) => {
  const [{ view }] = useSchedule()
  const date = view.firstDay
  const { leaves, holiday, restDay } = getResources(shiftsRow, date, view)

  const nonWorkableLeaves = leaves.some((leave) => !leave.workable)
  const workable = !nonWorkableLeaves && !restDay
  const showShiftCells = workable || shiftsRow.hasShifts

  if (shiftsRow.isDisabled(view, date)) {
    return (
      <WrapperCell key={shiftsRow.id} minWidth="full">
        <DisabledCell />
      </WrapperCell>
    )
  }

  return (
    <WrapperCell key={shiftsRow.id} minWidth="full">
      {!!holiday && (
        <Box padding="s4">
          <BankHolidayItem holiday={holiday} />
        </Box>
      )}
      {!!leaves &&
        leaves.map((leave) => (
          <Box key={leave.id} padding="s4">
            <LeaveItem leave={leave} shiftsRow={shiftsRow} date={date} />
          </Box>
        ))}
      {!!restDay && (
        <Box padding="s4">
          <RestDayCell shiftsRow={shiftsRow} restDay={restDay} />
        </Box>
      )}
      {showShiftCells && (
        <ShiftsGrid
          shiftsRow={shiftsRow}
          view={view}
          columns={columns}
          visibleDefaultShifts={visibleDefaultShifts}
        />
      )}
    </WrapperCell>
  )
}

export default observer(DailyRow)
